<template>
  <div class="flex flex-col">
    <div class="flex flex-row gap-2">
      <p class="font-bold mb-1">{{ label }}</p>
      <EmailCompletionToggleButton v-model="sendCompletionEmail" @change="sendCompletionEmailChanged"></EmailCompletionToggleButton>
    </div>
    <div class="flex flex-row gap-2 text-sm">
      <i class="pi pi-user my-auto"></i>
      <Button
        text
        :label="getEntityDisplay(entity)"
        severity="secondary"
        class="w-fit p-0!"
        @click="$emit('entitySelected', entity)"
        pt:label:class="truncate"
      ></Button>
    </div>
    <div v-if="entity.email" class="flex flex-row gap-2 text-sm">
      <i class="pi pi-envelope my-auto"></i>
      <p class="w-full break-words" data-test="entityEmail">{{ entity.email }}</p>
    </div>
    <div v-if="entity.entityPhone" class="flex flex-row break-words gap-2 text-sm">
      <i class="pi pi-phone my-auto"></i>
      <p class="w-full break-words" data-test="entityPhone">{{ entity.entityPhone }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProjectRole } from "@/enums/ProjectRole";
import { getEntityDisplay } from "@/services/Utility";
import type { Entity } from "@/types/Entity";

const sendCompletionEmail = defineModel<boolean>();

const emit = defineEmits<{
  entitySelected: [entity: Entity];
}>();

interface Props {
  label: string;
  projectId: string;
  entity: Entity;
  type: ProjectRole;
  drawNumber: number;
}
const props = defineProps<Props>();

const sendCompletionEmailChanged = (): void => {
  nextTick(() =>
    axios
      .post(
        `/project-entity/${props.projectId}/${props.entity.entityId}/${props.type}/${props.drawNumber}/update-send-complete-email/${sendCompletionEmail.value}`
      )
      .then((response) =>
        handleApiResponse(
          response,
          (data: any) => {
            success("Success", "Approval email settings updated");
          },
          (errors: ApiError[]) => {
            error("An error occurred", errors[0].message);
            sendCompletionEmail.value = !sendCompletionEmail.value;
          }
        )
      )
      .catch((e) => errorApi(e))
  );
};
</script>
